<sim-component-loading-container
	errorMessage="{{ T.SHARED_MEDIA_LIBRARY_NO_MEDIAS_FOUND | translate }}"
	[errorLoading]="mediaSet?.medias?.length === 0"
/>

@if (!mediaSet?.medias?.length) {
	<sim-panel-content-warning-container
		[warningTitle]="T.MEDIALIBRARY_PANEL_CONTENT_WARNING_TITLE | translate"
		[warningDescription]="T.MEDIALIBRARY_PANEL_CONTENT_WARNING_DESCRIPTION | translate"
	/>
} @else {
	@if (mediaSet?.medias?.length > 9) {
		<mat-tab-group
			[mat-stretch-tabs]="false"
			color="accent"
			class="tabContainer"
			[class.mediaPlayerOffline]="mediaPlayer?.webSocket?.activityState === ActivityState.Inactive"
		>
			<mat-tab label="{{ T.SHARED_MEDIA_LIBRARY_IMAGES | translate }}">
				<div class="tabContent">
					<div class="mediaHolder">
						<ng-container [ngTemplateOutlet]="mediaCardImage" />
						@if ((mediaSet?.medias | mediaFilter: MediaType.Image)?.length === 0) {
							<ng-container
								[ngTemplateOutlet]="mediasForCategoryEmpty"
								[ngTemplateOutletContext]="{
									$implicit: {text: 'Image', icon: 'fad fa-file-image'},
								}"
							/>
						}
					</div>
				</div>
			</mat-tab>
			<mat-tab label="{{ T.SHARED_MEDIA_LIBRARY_AUDIO | translate }}">
				<div class="tabContent">
					@if (hasMediaWithAudio) {
						<div class="volumeSlider fixed-div">
							<mat-slider color="accent" [min]="0" [max]="100" style="width: 100%">
								<input matSliderThumb [value]="volume" (valueChange)="volumeChanged($event)" />
							</mat-slider>
							<button
								color="accent"
								mat-icon-button
								(click)="volume === 0 ? unMute() : mute()"
								[class.on]="volume === 0"
								style="margin-right: 12px"
							>
								<mat-icon class="svgIcon" [svgIcon]="volume === 0 ? 'audio_speaker_not' : 'audio_speaker'" />
							</button>
						</div>
					}
					<div class="mediaHolder listView" style="margin-top: 50px !important">
						<ng-container [ngTemplateOutlet]="mediaCardAudio" [ngTemplateOutletContext]="{$implicit: {listView: true}}" />
						@if ((mediaSet?.medias | mediaFilter: MediaType.Audio)?.length === 0) {
							<ng-container
								[ngTemplateOutlet]="mediasForCategoryEmpty"
								[ngTemplateOutletContext]="{
									$implicit: {text: 'Audio', icon: 'fad fa-file-audio'},
								}"
							/>
						}
					</div>
				</div>
			</mat-tab>
			<mat-tab label="{{ T.SHARED_MEDIA_LIBRARY_VIDEOS | translate }}">
				<div class="tabContent">
					@if (hasMediaWithAudio) {
						<div class="volumeSlider fixed-div">
							<mat-slider color="accent" [min]="0" [max]="100" style="width: 100%">
								<input matSliderThumb [value]="volume" (valueChange)="volumeChanged($event)" />
							</mat-slider>
							<button
								color="accent"
								mat-icon-button
								(click)="volume === 0 ? unMute() : mute()"
								[class.on]="volume === 0"
								style="margin-right: 12px"
							>
								<mat-icon class="svgIcon" [svgIcon]="volume === 0 ? 'audio_speaker_not' : 'audio_speaker'" />
							</button>
						</div>
					}
					<div class="mediaHolder" style="margin-top: 60px !important">
						<ng-container [ngTemplateOutlet]="mediaCardVideo" />
						@if ((mediaSet?.medias | mediaFilter: MediaType.Video)?.length === 0) {
							<ng-container
								[ngTemplateOutlet]="mediasForCategoryEmpty"
								[ngTemplateOutletContext]="{
									$implicit: {text: 'Video', icon: 'fad fa-file-video'},
								}"
							/>
						}
					</div>
				</div>
			</mat-tab>
			<mat-tab label="PDF">
				<div class="tabContent">
					<div class="mediaHolder">
						<ng-container [ngTemplateOutlet]="mediaCardPDF" />
						@if ((mediaSet?.medias | mediaFilter: MediaType.PDF)?.length === 0) {
							<ng-container
								[ngTemplateOutlet]="mediasForCategoryEmpty"
								[ngTemplateOutletContext]="{
									$implicit: {text: 'PDF', icon: 'fad fa-file-pdf'},
								}"
							/>
						}
					</div>
				</div>
			</mat-tab>
			<mat-tab label="PowerPoint">
				<div class="tabContent">
					<div class="mediaHolder">
						<ng-container [ngTemplateOutlet]="mediaCardPPT" />
						@if ((mediaSet?.medias | mediaFilter: MediaType.PowerPoint)?.length === 0) {
							<ng-container
								[ngTemplateOutlet]="mediasForCategoryEmpty"
								[ngTemplateOutletContext]="{
									$implicit: {
										text: 'PowerPoint',
										icon: 'fad fa-file-powerpoint',
									},
								}"
							/>
						}
					</div>
				</div>
			</mat-tab>
		</mat-tab-group>
	}

	@if (mediaSet?.medias?.length <= 9) {
		<div class="tabContent mediaContainer">
			<div class="mediaHolder">
				<ng-container [ngTemplateOutlet]="mediaCardImage" />
				<ng-container [ngTemplateOutlet]="mediaCardAudio" [ngTemplateOutletContext]="{$implicit: {listView: false}}" />
				<ng-container [ngTemplateOutlet]="mediaCardVideo" />
				<ng-container [ngTemplateOutlet]="mediaCardPDF" />
				<ng-container [ngTemplateOutlet]="mediaCardPPT" />
			</div>
		</div>
	}
}

<ng-template #mediaCardAudio let-options [ngAs]="AudioCardData">
	@for (media of mediaSet?.medias | mediaFilter: MediaType.Audio; track media) {
		<div class="mediaCardElement">
			<sim-media-card-audio
				[media]="media"
				[listView]="options.listView"
				[mediaPlayer]="mediaPlayer"
				(toggleMedia)="toggleMedia.emit({player: $event.player, media: $event.media})"
			/>
		</div>
	}
</ng-template>

<ng-template #mediaCardImage>
	@for (media of mediaSet?.medias | mediaFilter: MediaType.Image; track media) {
		<div class="mediaCardElement">
			<sim-media-card-image
				[media]="media"
				[mediaPlayer]="mediaPlayer"
				(toggleMedia)="toggleMedia.emit({player: $event.player, media: $event.media})"
			/>
		</div>
	}
</ng-template>

<ng-template #mediaCardPDF>
	@for (media of mediaSet?.medias | mediaFilter: MediaType.PDF; track media) {
		<div class="mediaCardElement">
			<sim-media-card-pdf
				[media]="media"
				[mediaPlayer]="mediaPlayer"
				(toggleMedia)="toggleMedia.emit({player: $event.player, media: $event.media})"
			/>
		</div>
	}
</ng-template>

<ng-template #mediaCardVideo>
	@for (media of mediaSet?.medias | mediaFilter: MediaType.Video; track media) {
		<div class="mediaCardElement">
			<sim-media-card-video
				[media]="media"
				[mediaPlayer]="mediaPlayer"
				(toggleMedia)="toggleMedia.emit({player: $event.player, media: $event.media})"
			/>
		</div>
	}
</ng-template>

<ng-template #mediaCardPPT>
	@for (media of mediaSet?.medias | mediaFilter: MediaType.PowerPoint; track media) {
		<div class="mediaCardElement">
			<sim-media-card-power-point
				[media]="media"
				[mediaPlayer]="mediaPlayer"
				(toggleMedia)="toggleMedia.emit({player: $event.player, media: $event.media})"
			/>
		</div>
	}
</ng-template>

<ng-template #mediasForCategoryEmpty let-options [ngAs]="MediaLibraryPanelData">
	<div class="noMediasForThisCategoryFound">
		<div class="text mat-h2">
			{{ T.SHARED_MEDIA_LIBRARY_NO_FILES | translate: {fileType: options?.text} }}
		</div>

		<div class="icon">
			<i class="fad {{ options?.icon }} fa-4x"></i>
		</div>
	</div>
</ng-template>
